import styled from '@emotion/styled';
import React from 'react';

interface TextFieldProps {
  value: string | undefined;
  onChange: (value: string) => void;
  multiline?: boolean;
  placeholder?: string;
}

const TextField: React.FC<TextFieldProps> = ({ value, onChange, multiline, placeholder }) => {
  if (multiline) {
    return <TextArea value={value ?? ''} rows={3} placeholder={placeholder} onChange={(e) => onChange(e.target.value)} />;
  }
  return <Input type="text" value={value ?? ''} placeholder={placeholder} onChange={(e) => onChange(e.target.value)} />;
};

export default TextField;

const Input = styled.input`
  width: 100%;
  min-width: 0;
  padding: 4px 6px;
  font-size: 13px;
  color: #111827;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  outline: none;

  &:focus {
    border-color: #9ca3af;
  }
`;

const TextArea = styled.textarea`
  width: 100%;
  min-width: 0;
  padding: 4px 6px;
  font-size: 13px;
  color: #111827;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  outline: none;
  resize: vertical;
  font-family: inherit;

  &:focus {
    border-color: #9ca3af;
  }
`;
